import React, { useState } from 'react';

const ImageGallery = ({ onBack, images = [], loading, error, lastFetched }) => {
  const [modalUrl, setModalUrl] = useState(null);

  // Prevent right-click and drag for download
  const preventDownload = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div className="flex flex-col h-full items-center">
      <div className="w-full max-w-4xl flex items-center justify-between mb-4 px-4">
        <h1 className="font-['Dancing_Script'] text-2xl font-bold text-gray-900 text-center flex-1">
          The Bela Experience
        </h1>
        <button onClick={onBack} className="ml-4 px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 text-gray-700 text-sm font-semibold">Back to chat</button>
      </div>
      <div className="w-full max-w-4xl text-xs text-gray-600 mb-2 px-4">Viewing photos will require subscription starting 15 July 2025</div>
      {loading && <div>Loading images...</div>}
      {error && <div className="text-red-500">{error}</div>}
      <div className="flex-1 w-full flex justify-center overflow-y-auto pb-2">
        <div className="w-full max-w-4xl mx-auto px-4">
          <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))' }}>
            {images.map((url, idx) => (
              <div
                key={idx}
                className="relative bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center cursor-pointer shadow hover:shadow-lg transition-shadow"
                style={{ aspectRatio: '1 / 1', minWidth: 0 }}
                onClick={() => setModalUrl(url)}
              >
                <img
                  src={url}
                  alt={`Gallery ${idx}`}
                  className="object-contain w-full h-full select-none pointer-events-auto"
                  onContextMenu={preventDownload}
                  draggable={false}
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Modal for full image view */}
      {modalUrl && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80" onClick={() => setModalUrl(null)}>
          <img
            src={modalUrl}
            alt="Full size"
            className="max-w-full max-h-full rounded-lg shadow-lg select-none"
            onContextMenu={preventDownload}
            draggable={false}
            onClick={e => e.stopPropagation()}
          />
          <button
            className="absolute top-4 right-4 bg-white text-gray-800 rounded-full p-2 shadow hover:bg-gray-200"
            onClick={() => setModalUrl(null)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
